var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "timeline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "timeline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "history-line",
    transform: "translate(1, 1)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C15.5228,0 20,4.47715 20,10 C20,15.5228 15.5228,20 10,20 C4.47715,20 0,15.5228 0,10 L2,10 C2,14.4183 5.58172,18 10,18 C14.4183,18 18,14.4183 18,10 C18,5.58172 14.4183,2 10,2 C7.25022,2 4.82447,3.38734 3.38451,5.50024 L6,5.5 L6,7.5 L0,7.5 L0,1.5 L2,1.5 L1.99989,3.99918 C3.82434,1.57075 6.72873,0 10,0 Z M11,5 L10.9998,9.585 L14.2426,12.8284 L12.8284,14.2426 L8.9998,10.413 L9,5 L11,5 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.e2451d6574a25e9e16a5cbba6e47ca2d.svg";
export { ForwardRef as ReactComponent };